/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Cmp_PrivacyInputs */

const en_pc_online_cmp_privacy = /** @type {(inputs: Pc_Online_Cmp_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files stay on your device`)
};

const zh_pc_online_cmp_privacy = /** @type {(inputs: Pc_Online_Cmp_PrivacyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件留在你的设备上`)
};

/**
* | output |
* | --- |
* | "Files stay on your device" |
*
* @param {Pc_Online_Cmp_PrivacyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_cmp_privacy = /** @type {((inputs?: Pc_Online_Cmp_PrivacyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Cmp_PrivacyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_cmp_privacy(inputs)
	return zh_pc_online_cmp_privacy(inputs)
});
export { pc_online_cmp_privacy as "pc.online.cmp.privacy" }